import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import UserListComponent from "../components/user/UserListComponent";
import UserFormComponent from "../components/user/UserFormComponent";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import UserShowComponent from "../components/user/UserShowComponent";
import HelpComponent from "../components/HelpComponent";

const UsersPage = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {action} = useParams();

  useEffect(() => {
    document.title = t('users') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/user')
  }, []);

  return (
    <div className="UsersPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/user"}/>
      <Panel>
        <UserListComponent/>
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/user');
               }}>
        <UserFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/user');
               }}>
        <UserShowComponent/>
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(UsersPage);
